/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApiMethodType } from './apiMethodType';
import { Channel } from './channel';
import { ContentSource } from './contentSource';
import { PageConfigurationProcessDto } from './pageConfigurationProcessDto';
import { PagePosition } from './pagePosition';
import { PostMethodRequestEnum } from './postMethodRequestEnum';
import { ResponseType } from './responseType';

export interface PageConfigModel { 
    id?: string;
    pageName?: string;
    pageId?: string;
    serviceProviderId?: string;
    shortCode?: string;
    keyNumber?: string;
    pagePosition?: PagePosition;
    responseType?: ResponseType;
    displayText?: string;
    nextPage?: string;
    previousPage?: string;
    pages?: Array<PageConfigurationProcessDto>;
    userInput?: string;
    deliveryChannel?: Channel;
    contentSourceParam?: string;
    contentUrl?: string;
    apiMethodType?: ApiMethodType;
    postMethodRequestType?: PostMethodRequestEnum;
    contentSource?: ContentSource;
    partnerId?: string;
    partnerContentId?: string;
    airtelUrl?: string;
    errorMessage?: string;
    pageSetupStatus?: boolean;
    dateCreated?: Date;
    headerText?: string;
    campaignId?: string;
}